import React, { useEffect } from "react";
import BlankPage from "./blank";
import DashboardModule from "./dashboard";
import useFetchData from "../../hooks/useFetchData";
import MyLoader from "../../component/loader";

export default function Dashboard() {
  useEffect(() => {
    document.title = "Dashboard";
  }, []);

  const {
    data: campaigns,
    error: campaignsError,
    isLoading: campaignsLoading,
  } = useFetchData({ dataType: "campaigns" });
  if (campaignsLoading) return <MyLoader />;
  else
    return campaigns?.data?.length > 0 ? (
      <DashboardModule />
    ) : (
      <>
        <BlankPage />
        <div className="fixed w-full h-full top-0 xl:w-[calc(100%-278px)] right-0 z-[150] blur-lg backdrop-blur-md">
          <div className="mt-[100px]">
            <DashboardModule isEmpty />
          </div>
        </div>
      </>
    );
}
